// 商品ページの画像スライダー専用スクリプト
document.addEventListener("click", function (e) {
  // クリックされたのが専用の矢印ボタンか？
  const btn = e.target.closest("[data-detail-arrow]");
  if (!btn) return; // 違えば何もしない

  // ボタンが属している専用ラッパーを探す
  const wrapper = btn.closest("[data-detail-slider]");
  if (!wrapper) return;

  // 中のスライダー要素を取得
  const slider = wrapper.querySelector(".detail-slider");
  if (!slider) return;

  // スクロール幅を計算（画像1枚＋gap分）
  const first = slider.firstElementChild;
  if (!first) return;
  const styles = getComputedStyle(slider);
  const gap = parseFloat(styles.gap || styles.columnGap || "0");
  const step = Math.round(first.getBoundingClientRect().width + gap);

  // 左右にスクロール
  slider.scrollBy({
    left: btn.classList.contains("left") ? -step : step,
    behavior: "smooth"
  });
}, false);

// （オプション）端まで行ったらボタンを薄くする処理
(function () {
  function attach(wrapper) {
    const slider = wrapper.querySelector(".detail-slider");
    const left = wrapper.querySelector("[data-detail-arrow].left");
    const right = wrapper.querySelector("[data-detail-arrow].right");
    if (!slider || !left || !right) return;

    const update = () => {
      const max = slider.scrollWidth - slider.clientWidth;
      left.disabled = slider.scrollLeft <= 2;
      right.disabled = slider.scrollLeft >= max - 2;
    };

    slider.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  document.querySelectorAll("[data-detail-slider]").forEach(attach);
})();
